/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, {Component} from 'react';
// styles
import injectSheet from 'react-jss';
import styles from 'material/autofilltext/autofilltext_styles';
import DropDownItem from 'material/dropdowns/searchabledropdown/dropdownitem/dropdownitem';
import Group from 'material/group/group';
import Field from 'material/form/field/field_container';

/* ========== ~~~~~~~~~~ FORM : AUTOCOMPLETETEXT : CHILD ~~~~~~~~~~ ========== */
// COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AutoCompleteTextField extends Component {

    constructor(props) {
        super(props);  
        this.state = {
            filteredList: [],
            searchTerm: '',
            active: false
        };
    }

    handleBlur = (e) => {
        this.props.handleBlur(e.target.value);
    }

    handleChange = (e) => {
        e.preventDefault();
        const value = e.target.value;
        let filteredItems = [];
        if(value.length > 0) {
            let initialItems = this.props.list.map(item => ({name: item.name, value: item.value.toLowerCase()}));
            filteredItems = initialItems.filter(item => item.value.indexOf(value.toLowerCase()) >= 0);
        }
        this.setState({filteredList: filteredItems, active: !!(filteredItems.length > 0), searchTerm: value});
        this.props.handleSelect(value);
    }

    handleSelect = item => {
        this.setState({active: false, searchTerm: ''});
        this.props.handleSelect(item.value);
    };

    renderItems = ()=> (
        this.state.filteredList.map((item, i)=>{
            return <DropDownItem handleSelect={this.handleSelect} searchTerm={this.state.searchTerm} name={item.name} value={item.value} itemSelected={this.state.filteredList[i] === item} key={i} index={i} item={item}  />
        })
    )

    render() {
        return (
            <Group name={`menuItems ${this.props.classes.autotextfill}`}  >
                    <Field
                        type={this.props.type}
                        name={this.props.name}
                        placeholder={this.props.placeholder}
                        label={this.props.label}
                        info={this.props.info}
                        handleFocus={this.handleFocus}
                        value={this.props.value}
                        handleBlur={this.handleBlur}
                        handleKeyDown={this.handleKeyDown}
                        handleChange={this.handleChange}
                        valid={this.props.valid}
                        required={this.props.required}
                    />
                <Group name={`items active-${this.state.active}`}>
                    {this.renderItems()}
                </Group>
            </Group>
        );
    }

};


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(AutoCompleteTextField);